module.exports = function getResource(label, vars = []) {
    const resources = {
        myGallery: 'L’activité de ma galerie',
        myPhotos: 'Mes photos',
        noPhotos: 'Vous n’avez pas encore de photos.',
        uploadAPhoto: 'Télécharger une photo ou une vidéo pour commencer.',
        addAPhoto: 'Ajouter une photo',
        myLovedPhotos: 'Mes photos favorites',
        noLovedPhotos: 'Vous n’avez pas encore aimé de photos.',
        collectYourPhotos: 'Rassemblez vos photos favorites en cliquant sur',
        exploreTheGallery: 'Explorer la galerie'
    };
    return resources[label];
};
